export default __webpack_public_path__ + "static/profile-518b94caac610b868acb0ce725e165f4.gif";